/* «¿Ya tienes el libro?» · ampliar les portades dels recursos (sections/digital-experience)
   Cada portada ampliable és un <button data-dx-zoom-src> amb la imatge gran, les seves mides i el títol.
   En clicar-la s'obre el <dialog data-dx-zoom> de la mateixa secció amb aquella portada en gran:
   - es veu a l'instant la miniatura (ja carregada) i, quan arriba, la versió gran (sense moure res: mides fixes);
   - fletxes, tecles ← → i lliscament amb el dit per passar a les altres portades de la secció;
   - Esc, la creu o un clic fora de la finestra la tanquen; el focus torna a la portada clicada i la pàgina no es mou.
   Escoltes al document: continua funcionant quan l'editor del tema torna a pintar la secció. */
(function () {
  'use strict';
  if (window.__fbZoomReady) return;
  window.__fbZoomReady = true;

  function triggers(dialog) {
    var section = dialog.closest('section') || document;
    return Array.prototype.slice.call(section.querySelectorAll('[data-dx-zoom-src]'));
  }

  function show(dialog, index) {
    var list = triggers(dialog);
    if (!list.length) return;
    index = Math.max(0, Math.min(index, list.length - 1));
    dialog._index = index;
    var trigger = list[index];
    var img = dialog.querySelector('[data-dx-zoom-img]');
    var title = trigger.getAttribute('data-dx-zoom-title') || '';
    var src = trigger.getAttribute('data-dx-zoom-src');
    var thumb = trigger.querySelector('img');
    // Mides reals de la portada (no img.width: quan la imatge es veu, torna la mida pintada a la pantalla).
    var w = +trigger.getAttribute('data-dx-zoom-w') || 1241;
    var h = +trigger.getAttribute('data-dx-zoom-h') || 1755;
    img.setAttribute('width', w);
    img.setAttribute('height', h);
    img.alt = title;
    // Primer la miniatura (a la memòria cau), després la gran quan s'hagi baixat.
    if (thumb && thumb.currentSrc) img.src = thumb.currentSrc;
    var big = new Image();
    big.onload = function () { if (dialog._index === index) img.src = src; };
    big.src = src;
    if (!thumb || !thumb.currentSrc) img.src = src;
    dialog.querySelector('[data-dx-zoom-heading]').textContent = title;
    // Proporció del document: a la pantalla del mòbil l'escenari s'ajusta a la portada (CSS --dx-zoom-ratio).
    dialog.style.setProperty('--dx-zoom-ratio', w + ' / ' + h);
    var prev = dialog.querySelector('[data-dx-zoom-prev]');
    var next = dialog.querySelector('[data-dx-zoom-next]');
    prev.hidden = next.hidden = list.length < 2;
    prev.disabled = index === 0;
    next.disabled = index >= list.length - 1;
    dialog.querySelector('[data-dx-zoom-counter]').textContent = list.length > 1 ? (index + 1) + ' / ' + list.length : '';
  }

  function keepScroll(y) {
    if (typeof y !== 'number' || Math.abs(window.pageYOffset - y) < 2) return;
    var html = document.documentElement;
    var previous = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, y);
    html.style.scrollBehavior = previous;
  }

  function open(trigger) {
    var section = trigger.closest('section');
    var dialog = section && section.querySelector('[data-dx-zoom]');
    if (!dialog || typeof dialog.showModal !== 'function') {
      // Navegadors sense <dialog>: la imatge gran en una pestanya nova.
      window.open(trigger.getAttribute('data-dx-zoom-src'), '_blank', 'noopener');
      return;
    }
    dialog._opener = trigger;
    dialog._scrollY = window.pageYOffset;
    show(dialog, triggers(dialog).indexOf(trigger));
    // Bloqueja el desplaçament de la pàgina sense que es mogui: es compensa l'amplada de la barra de desplaçament.
    var bar = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (bar > 0) { document.body.style.paddingRight = bar + 'px'; dialog._padded = true; }
    dialog.showModal();
    var close = dialog.querySelector('[data-dx-zoom-close]');
    if (close) close.focus({ preventScroll: true });
    keepScroll(dialog._scrollY);
  }

  function cleanup(dialog) {
    if (!document.querySelector('dialog[open]')) document.body.style.overflow = '';
    if (dialog._padded) { document.body.style.paddingRight = ''; dialog._padded = false; }
    var opener = dialog._opener;
    dialog._opener = null;
    if (opener && document.contains(opener)) {
      try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); }
    }
    keepScroll(dialog._scrollY);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-dx-zoom-src]');
    if (trigger) { open(trigger); return; }
    var dialog = event.target.closest('[data-dx-zoom]');
    if (!dialog) return;
    // Clic al fons fosc (fora del panell) o a la creu: tanca.
    if (event.target === dialog || event.target.closest('[data-dx-zoom-close]')) { dialog.close(); return; }
    if (event.target.closest('[data-dx-zoom-prev]')) show(dialog, dialog._index - 1);
    else if (event.target.closest('[data-dx-zoom-next]')) show(dialog, dialog._index + 1);
  });

  document.addEventListener('keydown', function (event) {
    var dialog = document.querySelector('[data-dx-zoom][open]');
    if (!dialog) return;
    if (event.key === 'ArrowLeft') { event.preventDefault(); show(dialog, dialog._index - 1); }
    else if (event.key === 'ArrowRight') { event.preventDefault(); show(dialog, dialog._index + 1); }
  });

  // L'esdeveniment «close» no puja pel document: s'escolta a cada finestra (també a les que l'editor torna a pintar).
  document.addEventListener('close', function (event) {
    if (event.target && event.target.matches && event.target.matches('[data-dx-zoom]')) cleanup(event.target);
  }, true);

  // Lliscament amb un sol dit (sense interferir amb el pessic per fer zoom de la pàgina).
  var touch = null;
  document.addEventListener('touchstart', function (event) {
    var stage = event.target.closest && event.target.closest('[data-dx-zoom] .dx-zoom__stage');
    touch = stage && event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
  }, { passive: true });
  document.addEventListener('touchend', function (event) {
    if (!touch || event.changedTouches.length !== 1) { touch = null; return; }
    var dx = event.changedTouches[0].clientX - touch.x;
    var dy = event.changedTouches[0].clientY - touch.y;
    touch = null;
    if (window.visualViewport && window.visualViewport.scale > 1.05) return;
    if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    var dialog = document.querySelector('[data-dx-zoom][open]');
    if (dialog) show(dialog, dialog._index + (dx < 0 ? 1 : -1));
  }, { passive: true });
})();
